export const maximumMediaSize = 0.95;
